// extracted by mini-css-extract-plugin
module.exports =  {"quickAddContent":"JVcoXT","quickAddOptions":"rTxq8H"};